import { Flex, Box } from '@chakra-ui/react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';

import { TextLabel } from 'uiToolkitV1/Typography';

import { updateAddViolationDrawer, useSelectAddViolationDrawerData } from '../slice/addViolation.slice';

const SEVERITY_OPTIONS = ['Low', 'Medium', 'High'];

const SeverityDropdown = () => {
  const { severity } = useSelectAddViolationDrawerData();
  const dispatch = useDispatch();

  const handleSeverityChange = (value: string) => {
    dispatch(
      updateAddViolationDrawer({
        severity: value,
      })
    );
  };

  return (
    <Flex flexDir="column" alignItems="flex-start" w="100%">
      <TextLabel color="text.g2">Severity</TextLabel>
      <Box w="100%">
        <Select value={severity} onValueChange={handleSeverityChange}>
          <SelectTrigger style={{ width: '100%', textAlign: 'left' }}>
            <SelectValue placeholder="Select Severity" />
          </SelectTrigger>
          <SelectContent style={{ maxWidth: '100%' }}>
            <SelectGroup>
              {SEVERITY_OPTIONS.map((option) => (
                <SelectItem key={option} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </Box>
    </Flex>
  );
};

export { SeverityDropdown };
